import React from "react";
import { Link } from "react-router-dom";

export const PrivacyPolicy = () => {
  return (
    <div>
      <nav style={{
        background: 'rgba(255, 255, 255, 0.95)',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        padding: '20px 0',
        position: 'fixed',
        width: '100%',
        top: 0,
        zIndex: 1000
      }}>
        <div className="container">
          <Link 
            to="/" 
            style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#3b82f6',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center'
            }}
          >
            <i className="fa-solid fa-arrow-left" style={{ marginRight: '8px' }}></i>
            Voltar para o site
          </Link>
        </div>
      </nav>

      <div id="privacy-policy" className="text-left" style={{ padding: '120px 0 80px', background: '#fff' }}>
        <div className="container">
        <div className="row">
          <div className="col-md-10 col-md-offset-1">
            <div className="section-title" style={{ marginBottom: '40px' }}>
              <h2 style={{ textAlign: 'left' }}>Política de Privacidade</h2>
              <p style={{ fontSize: '14px', color: '#64748b' }}>
                Última atualização: {new Date().toLocaleDateString('pt-BR')}
              </p>
            </div>

            <div style={{ lineHeight: '1.8' }}>
              <h3>1. Introdução</h3>
              <p>
                A Cortex Prime Solutions ("nós", "nosso" ou "empresa") está comprometida em proteger 
                a privacidade e segurança dos dados pessoais de nossos clientes, usuários e visitantes. 
                Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos 
                suas informações pessoais em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018).
              </p>

              <h3>2. Informações que Coletamos</h3>
              <p>Coletamos as seguintes categorias de informações:</p>
              <ul style={{ marginLeft: '30px', listStyle: 'disc' }}>
                <li><strong>Dados de Identificação:</strong> nome, e-mail, telefone, endereço</li>
                <li><strong>Dados de Navegação:</strong> endereço IP, navegador, dispositivo, cookies</li>
                <li><strong>Dados Profissionais:</strong> empresa, cargo, área de atuação</li>
                <li><strong>Dados de Comunicação:</strong> mensagens enviadas através de formulários de contato</li>
              </ul>

              <h3>3. Como Usamos Suas Informações</h3>
              <p>Utilizamos seus dados pessoais para:</p>
              <ul style={{ marginLeft: '30px', listStyle: 'disc' }}>
                <li>Responder suas solicitações e fornecer suporte</li>
                <li>Desenvolver, fornecer e melhorar nossos serviços</li>
                <li>Enviar comunicações sobre nossos produtos e serviços (com seu consentimento)</li>
                <li>Cumprir obrigações legais e regulatórias</li>
                <li>Prevenir fraudes e garantir a segurança</li>
              </ul>

              <h3>4. Base Legal para o Tratamento de Dados</h3>
              <p>
                Processamos seus dados pessoais com base nas seguintes bases legais previstas na LGPD:
              </p>
              <ul style={{ marginLeft: '30px', listStyle: 'disc' }}>
                <li>Consentimento do titular dos dados</li>
                <li>Cumprimento de obrigação legal ou regulatória</li>
                <li>Execução de contrato ou procedimentos preliminares</li>
                <li>Exercício regular de direitos em processo judicial, administrativo ou arbitral</li>
                <li>Legítimo interesse da empresa</li>
              </ul>

              <h3>5. Compartilhamento de Dados</h3>
              <p>
                Não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros para 
                fins de marketing. Podemos compartilhar dados apenas com:
              </p>
              <ul style={{ marginLeft: '30px', listStyle: 'disc' }}>
                <li>Prestadores de serviços que nos auxiliam nas operações (ex: hospedagem, e-mail)</li>
                <li>Autoridades governamentais quando exigido por lei</li>
                <li>Parceiros de negócios com seu consentimento expresso</li>
              </ul>

              <h3>6. Segurança dos Dados</h3>
              <p>
                Implementamos medidas técnicas e organizacionais apropriadas para proteger seus dados pessoais 
                contra acesso não autorizado, alteração, divulgação ou destruição, incluindo:
              </p>
              <ul style={{ marginLeft: '30px', listStyle: 'disc' }}>
                <li>Criptografia de dados em trânsito e em repouso</li>
                <li>Controles de acesso rigorosos</li>
                <li>Monitoramento contínuo de segurança</li>
                <li>Treinamento regular da equipe sobre proteção de dados</li>
              </ul>

              <h3>7. Retenção de Dados</h3>
              <p>
                Mantemos seus dados pessoais apenas pelo tempo necessário para cumprir as finalidades 
                para as quais foram coletados, incluindo requisitos legais, contábeis ou de relatórios.
              </p>

              <h3>8. Seus Direitos (LGPD)</h3>
              <p>De acordo com a LGPD, você tem os seguintes direitos:</p>
              <ul style={{ marginLeft: '30px', listStyle: 'disc' }}>
                <li>Confirmação da existência de tratamento de dados</li>
                <li>Acesso aos seus dados pessoais</li>
                <li>Correção de dados incompletos, inexatos ou desatualizados</li>
                <li>Anonimização, bloqueio ou eliminação de dados desnecessários</li>
                <li>Portabilidade dos dados a outro fornecedor</li>
                <li>Eliminação dos dados tratados com seu consentimento</li>
                <li>Informação sobre compartilhamento de dados</li>
                <li>Revogação do consentimento</li>
              </ul>
              <p>
                Para exercer qualquer desses direitos, entre em contato através do e-mail: 
                <strong> contato@cortexps.com.br</strong>
              </p>

              <h3>9. Cookies</h3>
              <p>
                Utilizamos cookies e tecnologias similares para melhorar a experiência do usuário, 
                analisar o tráfego do site e personalizar conteúdo. Você pode gerenciar suas preferências 
                de cookies através das configurações do seu navegador.
              </p>

              <h3>10. Alterações nesta Política</h3>
              <p>
                Podemos atualizar esta Política de Privacidade periodicamente. A versão mais recente 
                sempre estará disponível em nosso site com a data da última atualização.
              </p>

              <h3>11. Encarregado de Dados (DPO)</h3>
              <p>
                Para questões relacionadas à proteção de dados, entre em contato com nosso 
                Encarregado de Dados:
              </p>
              <p>
                <strong>E-mail:</strong> dpo@cortexps.com.br<br />
                <strong>Telefone:</strong> +55 (48) 99822-7091
              </p>

              <h3>12. Contato</h3>
              <p>
                Para qualquer dúvida sobre esta Política de Privacidade ou sobre o tratamento 
                de seus dados pessoais, entre em contato:
              </p>
              <p>
                <strong>Cortex Prime Solutions</strong><br />
                E-mail: contato@cortexps.com.br<br />
                Telefone: +55 (48) 99822-7091
              </p>

              <div style={{ 
                marginTop: '40px', 
                padding: '20px', 
                background: '#f8fafc', 
                borderRadius: '12px',
                borderLeft: '4px solid #3b82f6' 
              }}>
                <p style={{ margin: 0, fontSize: '14px' }}>
                  <strong>Autoridade Nacional de Proteção de Dados (ANPD):</strong> Caso suas 
                  solicitações não sejam atendidas, você pode contatar a ANPD através do site 
                  <a href="https://www.gov.br/anpd" target="_blank" rel="noopener noreferrer" style={{ marginLeft: '5px' }}>
                    www.gov.br/anpd
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};
